const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9b5230ceaa12a0b3f24b73ba7e4b8065f1bc9d40"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"9b5230ceaa12a0b3f24b73ba7e4b8065f1bc9d40"};
      